import "@/App.css";
import "@/index.css";

// Landing page components
import UrgencyBanner from "./components/landing/UrgencyBanner";
import Navigation from "./components/landing/Navigation";
import Hero from "./components/landing/Hero";
import LogoMarquee from "./components/landing/LogoMarquee";
import StatsSection from "./components/landing/StatsSection";
import HowItWorks from "./components/landing/HowItWorks";
import FeaturesSection from "./components/landing/FeaturesSection";
import ComparisonSection from "./components/landing/ComparisonSection";
import TestimonialsSection from "./components/landing/TestimonialsSection";
import PricingSection from "./components/landing/PricingSection";
import FAQSection from "./components/landing/FAQSection";
import FinalCTA from "./components/landing/FinalCTA";
import Footer from "./components/landing/Footer";
import LiveActivityTicker from "./components/landing/LiveActivityTicker";
import StickyBottomCTA from "./components/landing/StickyBottomCTA";

function App() {
  return (
    <div className="App min-h-screen bg-surface-base text-white relative">
      {/* Ambient Background */}
      <div className="ambient-bg"></div>
      
      {/* Urgency Banner */}
      <UrgencyBanner />
      
      {/* Navigation */}
      <Navigation />
      
      {/* Main Content */}
      <main className="relative z-10">
        <Hero />
        <LogoMarquee />
        <StatsSection />
        <HowItWorks />
        <FeaturesSection />
        <ComparisonSection />
        <TestimonialsSection />
        <PricingSection />
        <FAQSection />
        <FinalCTA />
      </main>
      
      {/* Footer */}
      <Footer />
      
      {/* Floating Elements */}
      <LiveActivityTicker />
      <StickyBottomCTA />
    </div>
  );
}

export default App;
